import ko from 'knockout';
import viewModel from './trend-panel.vm';
import templateMarkup from 'raw-loader!./trend-panel.template.html';
    
    ko.components.register('assurance-trend-panel', { template: templateMarkup, viewModel: viewModel });

